"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Definition of the InfractionBase model
 * @author Harris Lummis
 */

var mixins_1 = require("@atlas/models/mixins");

var utils_1 = require("@atlas/models/utils");

var errors_1 = require("@atlas/models/errors");

var dynamodb_auto_marshaller_1 = require("@aws/dynamodb-auto-marshaller");

var each_1 = __importDefault(require("lodash/each"));

var changeCase_1 = require("@atlas/models/utils/changeCase");

var pickBy_1 = __importDefault(require("lodash/pickBy"));
/** Default values of enumerable properties of Infraction */


var defaults = {
  infractionId: '',
  clientId: '',
  objectId: '',
  startTime: null,
  endTime: null,
  violationType: null,
  allowVerification: null,
  infractionImgKey: '',
  parkImgKey: '',
  plateImgKey: '',
  plate: '',
  state: '',
  verified: false,
  rejectionReason: '',
  customerLink: ''
};
/** Represents a stored Infraction */

var Infraction =
/** @class */
function () {
  /**
   * Builds a new Infraction instance
   * @param values An object defining the attribute values of the infraction
   */
  function Infraction(props) {
    /** The UUID of the infraction */
    this.infractionId = defaults.infractionId;
    /** The UUID of the client to whom the infraction belongs */

    this.clientId = defaults.clientId;
    /** The UUID of the object that triggered the infraction */

    this.objectId = defaults.objectId;
    /** The start time of the infraction, if any */

    this.startTime = defaults.startTime;
    /** The end time of the infraction, if any */

    this.endTime = defaults.endTime;
    /** The type of violation, if any */

    this.violationType = defaults.violationType;
    /** Indicates whether verification by a third party is or is not allowed */

    this.allowVerification = defaults.allowVerification;
    /** S3 key of the infraction image */

    this.infractionImgKey = defaults.infractionImgKey;
    /** S3 key of the park image */

    this.parkImgKey = defaults.parkImgKey;
    /** S3 key of the chosen plate image */

    this.plateImgKey = defaults.plateImgKey;
    /** Plate text */

    this.plate = defaults.plate;
    /** State code of plate */

    this.state = defaults.state;
    /** Indicates whether infraction has been verified */

    this.verified = defaults.verified;
    /** Indicates why the infraction was rejected */

    this.rejectionReason = defaults.rejectionReason;
    /** Link for display of infraction to customer */

    this.customerLink = defaults.customerLink;

    var _a = __assign(__assign({}, defaults), props),
        infractionId = _a.infractionId,
        clientId = _a.clientId,
        objectId = _a.objectId,
        startTime = _a.startTime,
        endTime = _a.endTime,
        violationType = _a.violationType,
        allowVerification = _a.allowVerification,
        infractionImgKey = _a.infractionImgKey,
        parkImgKey = _a.parkImgKey,
        plateImgKey = _a.plateImgKey,
        plate = _a.plate,
        state = _a.state,
        verified = _a.verified,
        rejectionReason = _a.rejectionReason,
        customerLink = _a.customerLink;

    this.infractionId = infractionId || defaults.infractionId;
    this.clientId = clientId || defaults.clientId;
    this.objectId = objectId || defaults.objectId;
    this.violationType = violationType || defaults.violationType;
    this.allowVerification = allowVerification || defaults.allowVerification;
    this.infractionImgKey = infractionImgKey || defaults.infractionImgKey;
    this.parkImgKey = parkImgKey || defaults.parkImgKey;
    this.plateImgKey = plateImgKey || defaults.plateImgKey;
    this.plate = plate || defaults.plate;
    this.state = state || defaults.state;
    this.rejectionReason = rejectionReason || defaults.rejectionReason;
    this.customerLink = customerLink || defaults.customerLink;
    this.verified = typeof verified === 'boolean' ? verified : defaults.verified; // If necessary, convert numerically expressed dates to Date objects

    this.startTime = startTime instanceof Date ? startTime : startTime ? new Date(startTime) : defaults.startTime;
    this.endTime = endTime instanceof Date ? endTime : endTime ? new Date(endTime) : defaults.endTime;
  }
  /**
   * Creates a new Infraction instance from a DynamoDB Infraction item
   * @param item The DynamoDB item used as source data for the Infraction instance
   * @param marshaller An optional marshaller used to unmarshal item
   * @return A new Infraction instance
   */


  Infraction.FromDDBItem = function (item, marshaller) {
    if (item === void 0) {
      item = {};
    }

    if (marshaller === void 0) {
      marshaller = new dynamodb_auto_marshaller_1.Marshaller();
    }

    var _a = marshaller.unmarshallItem(item),
        infractionId = _a.infraction_id,
        clientId = _a.client_id,
        objectId = _a.object_id,
        startTime = _a.start_time,
        endTime = _a.end_time,
        violationType = _a.violation_type,
        allowVerification = _a.allow_verification,
        infractionImgKey = _a.img_key_infraction,
        parkImgKey = _a.img_key_park,
        plateImgKey = _a.img_key_plate,
        rejectionReason = _a.verification_rejection_reason_explained_json,
        customerLink = _a.customer_link,
        plate = _a.plate,
        state = _a.state,
        verified = _a.verified,
        rest = __rest(_a, ["infraction_id", "client_id", "object_id", "start_time", "end_time", "violation_type", "allow_verification", "img_key_infraction", "img_key_park", "img_key_plate", "verification_rejection_reason_explained_json", "customer_link", "plate", "state", "verified"]);

    if (Object.keys(rest).length > 0) {
      throw new errors_1.InvalidTypeError("unexpected keys during unmarshalling: " + Object.keys(rest));
    }

    return new this({
      infractionId: infractionId,
      clientId: clientId,
      objectId: objectId,
      startTime: startTime ? new Date(startTime) : null,
      endTime: endTime ? new Date(endTime) : null,
      violationType: violationType,
      allowVerification: allowVerification,
      infractionImgKey: infractionImgKey,
      parkImgKey: parkImgKey,
      plateImgKey: plateImgKey,
      plate: plate,
      state: state,
      verified: verified,
      rejectionReason: rejectionReason,
      customerLink: customerLink
    });
  };
  /**
   * Builds a new infraction from an object
   * @param obj The object from which to construct
   * @param opts Additional options that define how to construct the infraction
   * @return A new infraction instance
   */


  Infraction.FromObject = function (obj) {
    return utils_1.parseObject(this, obj);
  };
  /**
   * Builds a new infraction from an unmarshalled dynamodb item
   * @param item The unmarshalled item
   * @return A new infraction instance
   */


  Infraction.FromUnmarshalled = function (item) {
    var infractionImgKey = item.img_key_infraction,
        parkImgKey = item.img_key_park,
        plateImgKey = item.img_key_plate,
        rejectionReason = item.verification_rejection_reason_explained_json,
        rest = __rest(item, ["img_key_infraction", "img_key_park", "img_key_plate", "verification_rejection_reason_explained_json"]);

    return utils_1.parseObject(this, __assign({
      infractionImgKey: infractionImgKey,
      parkImgKey: parkImgKey,
      plateImgKey: plateImgKey,
      rejectionReason: rejectionReason
    }, rest));
  };
  /**
   * Gets a single infraction record by its id. If no infraction with a
   * matching id can be found, resolves to null.
   * @param input The input provided to the function
   * @return A promise that resolves to a new infraction record
   */


  Infraction.getById = function (_a) {
    var _this = this;

    var id = _a.id,
        clientId = _a.clientId,
        ddbClient = _a.ddbClient,
        tableName = _a.tableName;
    return new Promise(function (resolve, reject) {
      ddbClient.get({
        TableName: tableName,
        Key: {
          client_id: clientId,
          infraction_id: id
        }
      }, function (err, data) {
        if (err) {
          return reject(err);
        }

        if (data && data.Item) {
          // Item should always be defined if data is defined, but add check
          // for type-checking purposes
          return resolve(_this.FromUnmarshalled(data.Item));
        }

        return resolve(null);
      });
    });
  };
  /**
   * Find many infractions. Return up to "limit" results (may be less if filtered).
   * @param input Input defining the query
   * @return A promise that resolves to the found infractions as well as the
   * count of returned rows and the lastEvaluatedKey (to be used to continue pagination)
   */


  Infraction.find = function (_a) {
    var ddbClient = _a.ddbClient,
        clientId = _a.clientId,
        tableName = _a.tableName,
        limit = _a.limit,
        _b = _a.filter,
        filter = _b === void 0 ? {
      verified: false
    } : _b,
        _c = _a.order,
        order = _c === void 0 ? 'desc' : _c,
        _d = _a.orderBy,
        orderBy = _d === void 0 ? 'endTime' : _d,
        exclusiveStartKey = _a.exclusiveStartKey;
    var filterExpression = '#verif = :verif';
    var expressionAttributeNames = {
      '#cli': 'client_id',
      '#verif': 'verified',
      '#allow': filter.allowVerification && 'allow_verification',
      '#vType': filter.violationType && 'violation_type'
    };
    var expressionAttributeValues = {
      ':cli': clientId,
      ':verif': filter.verified || false,
      ':allow': filter.allowVerification,
      ':vType': filter.violationType
    };

    if (filter.allowVerification) {
      filterExpression += ' and #allow = :allow';
    }

    if (filter.violationType) {
      filterExpression += ' and #vType = :vType';
    }

    return new Promise(function (resolve, reject) {
      ddbClient.query({
        TableName: tableName,
        KeyConditionExpression: '#cli = :cli',
        Limit: limit,
        ExclusiveStartKey: exclusiveStartKey,
        FilterExpression: filterExpression,
        ExpressionAttributeNames: pickBy_1.default(expressionAttributeNames, function (v) {
          return v !== undefined;
        }),
        ExpressionAttributeValues: pickBy_1.default(expressionAttributeValues, function (v) {
          return v !== undefined;
        }),
        IndexName: "client_id-" + (orderBy === 'endTime' ? 'end_time' : 'start_time') + "-index",
        ScanIndexForward: order === 'asc'
      }, function (err, data) {
        if (err) {
          return reject(err);
        }

        var _a = data.Count,
            count = _a === void 0 ? 0 : _a,
            _b = data.Items,
            items = _b === void 0 ? [] : _b,
            lastEvaluatedKey = data.LastEvaluatedKey;
        return resolve({
          count: count,
          items: items.map(function (i) {
            return Infraction.FromUnmarshalled(i);
          }),
          lastEvaluatedKey: lastEvaluatedKey
        });
      });
    });
  };
  /**
   * Updates a single infraction record in dynamodb, or creates a new item
   * if one does not already exist and options allow for it.
   * @param params Input parameters defining update operation
   * @param options Options applied to update operation
   * @return A promise that resolves to the created/updated record or null if
   * no return value was desired.
   */


  Infraction.update = function (_a, options) {
    var key = _a.key,
        ddbClient = _a.ddbClient,
        tableName = _a.tableName,
        attributes = _a.attributes;

    if (options === void 0) {
      options = {
        returnValues: 'NONE',
        upsert: false,
        onEmpty: 'omit'
      };
    }

    return __awaiter(this, void 0, void 0, function () {
      var _b, returnValues, _c, upsert, _d, onEmpty, expressionAttributeValues, expressionAttributeNames, updateExpression, returnedAttributes;

      return __generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            _b = options.returnValues, returnValues = _b === void 0 ? 'NONE' : _b, _c = options.upsert, upsert = _c === void 0 ? false : _c, _d = options.onEmpty, onEmpty = _d === void 0 ? 'omit' : _d;
            expressionAttributeValues = {};
            expressionAttributeNames = {};
            updateExpression = '';
            each_1.default(attributes, function (val, name) {
              if (val === undefined || val === null || val === '') {
                if (onEmpty === 'omit') {
                  return;
                }
              }

              var realAttrName;

              switch (name) {
                case 'infractionImgKey':
                  realAttrName = 'img_key_infraction';
                  break;

                case 'parkImgKey':
                  realAttrName = 'img_key_park';
                  break;

                case 'plateImgKey':
                  realAttrName = 'img_key_plate';
                  break;

                case 'rejectionReason':
                  realAttrName = 'verification_rejection_reason_explained_json';
                  break;

                case 'infractionId':
                case 'clientId':
                  // Don't include key attributes in the update expression
                  return;

                default:
                  realAttrName = changeCase_1.snakeCase(name);
                  break;
              }

              var exprAttrName = "#" + name;
              var exprAttrVal = ":" + name;
              expressionAttributeNames[exprAttrName] = realAttrName;

              if (val === undefined || val === null || val === '') {
                // onEmpty must be nullify at this point
                expressionAttributeValues[exprAttrVal] = null;
              } else {
                expressionAttributeValues[exprAttrVal] = val instanceof Date ? val.getTime() : val;
              }

              updateExpression += (updateExpression ? ',' : 'SET') + " " + exprAttrName + " = " + exprAttrVal;
            });

            if (updateExpression === '') {
              // TODO: define custom error type
              throw new Error('update expression cannot be empty');
            }

            return [4
            /*yield*/
            , ddbClient.update({
              Key: {
                client_id: key.clientId,
                infraction_id: key.id
              },
              TableName: tableName,
              UpdateExpression: updateExpression,
              ExpressionAttributeNames: expressionAttributeNames,
              ExpressionAttributeValues: expressionAttributeValues,
              // Only apply a condition to check record's existence if upsert is not
              // true
              ConditionExpression: upsert ? undefined : 'attribute_exists(infraction_id)',
              ReturnValues: returnValues
            }).promise()];

          case 1:
            returnedAttributes = _e.sent().Attributes;

            if (returnedAttributes && returnValues !== 'NONE') {
              return [2
              /*return*/
              , Infraction.FromUnmarshalled(returnedAttributes)];
            }

            return [2
            /*return*/
            , null];
        }
      });
    });
  };
  /**
   * Creates a new unmarshalled ddb item from the calling instance
   * @returns An unmarshalled item
   */


  Infraction.prototype.toUnmarshalled = function () {
    var _a = this.toObject({
      case: 'snake'
    }),
        imgKeyInfraction = _a.infraction_img_key,
        imgKeyPark = _a.park_img_key,
        imgKeyPlate = _a.plate_img_key,
        rejectionReason = _a.rejection_reason,
        startTime = _a.start_time,
        endTime = _a.end_time,
        rest = __rest(_a, ["infraction_img_key", "park_img_key", "plate_img_key", "rejection_reason", "start_time", "end_time"]);

    return __assign({
      img_key_infraction: imgKeyInfraction,
      img_key_park: imgKeyPark,
      img_key_plate: imgKeyPlate,
      start_time: startTime ? startTime.getTime() : undefined,
      end_time: endTime ? endTime.getTime() : undefined,
      verification_rejection_reason_explained_json: rejectionReason
    }, rest);
  };
  /**
   * Marshalls the calling instance into a valid DynamoDB item representation of
   * the Infraction
   * @param marshaller The marshaller used to marshal instance properties into
   * an attribute map
   * @return A new DynamoDB attribute map representing the Infraction
   */


  Infraction.prototype.toDDBItem = function (marshaller) {
    if (marshaller === void 0) {
      marshaller = new dynamodb_auto_marshaller_1.Marshaller();
    }

    var _a = this.toObject({
      case: 'snake',
      dateType: 'number'
    }),
        imgKeyInfraction = _a.infraction_img_key,
        imgKeyPark = _a.park_img_key,
        imgKeyPlate = _a.plate_img_key,
        rejectionReason = _a.rejection_reason,
        rest = __rest(_a, ["infraction_img_key", "park_img_key", "plate_img_key", "rejection_reason"]);

    return marshaller.marshallItem(__assign({
      img_key_infraction: imgKeyInfraction,
      img_key_park: imgKeyPark,
      img_key_plate: imgKeyPlate,
      verification_rejection_reason_explained_json: rejectionReason
    }, rest));
  };
  /** Default values for enumerable properties */


  Infraction.DEFAULTS = defaults;
  return Infraction;
}();

exports.Infraction = Infraction;
mixins_1.applyMixins(Infraction, mixins_1.Objectable);
exports.default = Infraction;